import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Video from "../assets/gcasHero.mp4";

function Hero() {
	const videoRef = useRef(null);

	useEffect(() => {
		const video = videoRef.current;
		if (!video) return;

		const prefersReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		if (prefersReducedMotion) {
			video.pause();
			return;
		}

		const playPromise = video.play();
		if (playPromise !== undefined) {
			playPromise.catch(() => {
				setTimeout(() => video.play(), 1000);
			});
		}
	}, []);

	return (
		<section className="homeHero">
			<div className="homeHeroFrame">
				<video
					ref={videoRef}
					className="homeHeroVideo"
					src={Video}
					loop
					muted
					playsInline
					aria-hidden="true"
				/>
				<div className="homeHeroScrim" aria-hidden="true"></div>

				<div className="homeHeroContent">
					<h1 className="homeHeroHeadline">Culture that gathers us home.</h1>
					<p className="homeHeroSubcopy">
						Ghanaian and Canadian life, together in Regina: gatherings,
						celebration, and community that stays close all year.
					</p>
					<div className="homeHeroActions">
						<Link to="/events" className="btn btnPrimary">
							See our events
							<span className="btnIcon" aria-hidden="true">
								<svg
									width="15"
									height="15"
									viewBox="0 0 24 24"
									fill="none"
									stroke="currentColor"
									strokeWidth="2.5"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path d="M5 12h14"></path>
									<path d="m12 5 7 7-7 7"></path>
								</svg>
							</span>
						</Link>
						<ScrollLink
							spy={true}
							smooth={true}
							offset={-100}
							duration={500}
							href="/"
							to="about"
							className="btn btnGhost"
						>
							About us
						</ScrollLink>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Hero;
